module.exports = __webpack_public_path__ + "img/avatar1.2d61051f.png";